// extracted by mini-css-extract-plugin
export default {"gettingStartedPage":"styles_gettingStartedPage__swyJO","content":"styles_content__O8JnO","mainIntro":"styles_mainIntro__ZHVoY","contentContainer":"styles_contentContainer__MuJig"};